import React, { useState } from 'react';
import CustomerDetail from 'containers/Common/Customer/customerDetail';

export const BtnChiTietKhachHang = ({ item, onOpenModalKhachHang }) => {
    const [show, setShow] = useState(false);
    
    if(onOpenModalKhachHang) {
        return (
            <a href="#!" onClick={() => onOpenModalKhachHang(item)} className="blue btn-link">{item.TenKhachHang}</a>
        );
    }
    return (
        <>
            <a href="#!" onClick={() => setShow(true)} className="blue btn-link">{item.TenKhachHang}</a>
            {show && (
                <CustomerDetail
                    show={show}
                    onHide={() => setShow(false)}
                    data={{ CustomerID: item.CustomerID }}
                />
            )}
        </>
    );
};